import styled from 'styled-components';

const Header = styled.header.attrs({
  className: `w-full px-6 py-2 flex flex-col py-4 space-y-4`,
})``;

export default Header;
